import classNames from "classnames";
import { I18N } from "oc-I18N";
import React, { useState } from "react";
import { Zauneditor } from "../../pages/Zauneditor";
import { showFeedbackDialog } from "./Feedback";

export const actions = {
  Tutorial() {
    (APP.pageInstance as Zauneditor).showMouseTutorial();
  },
  Tour() {
    APP.joyrideTourStep = { grundriss: 0, zauneditor: 0 };
    APP.dirty();
  },
  Feedback() {
    showFeedbackDialog();
  },
};

export interface SimpleAssistantProps {
  children: JSX.Element;
  className: string;
  onClick: () => void;
  positionY: string;
  positionX: string;
  size: string;
}

export const SimpleAssistant = React.forwardRef(
  (
    {
      children,
      className,
      onClick,
      positionY = "top",
      positionX = "left",
      size = "big",
    }: Partial<SimpleAssistantProps>,
    ref: React.ForwardedRef<any>
  ) => {
    const [, update] = useState({});

    return (
      <div
        ref={ref}
        className={classNames(
          "assistant",
          "fade",
          "assistant-" + size,
          "assistant-" + positionY,
          "assistant-" + positionX,
          className
        )}
        role="complementary"
        aria-label={I18N("aria::Assistent")}
      >
        <button
          className={classNames("assistant-avatar fade")}
          title={I18N("Ich helfe Ihnen gerne!")}
          aria-label={I18N("aria::Assistent öffnen")}
          onClick={onClick}
          tabIndex={0}
        ></button>

        {children}
      </div>
    );
  }
);
